module.exports = __webpack_public_path__ + "static/media/demisuite1.38b6b2c5.jpg";